import { DishMeasurementDto, DishUnitMeasurementDto, PerPersonUnitDto } from '@/api/generated';
import {
  hasPerPersonBudget,
  perPersonUnits,
} from '@/views/processes/offerSubgroup/util/distributeSubgroupPortions.util.ts';

export type SubgroupUnitRule = {
  maxPerPerson?: number;
  minPerPerson?: number;
  perPersonUnit?: PerPersonUnitDto;
};

export const gramsPerPortion = (measurement?: DishMeasurementDto | null): number | null => {
  if (!measurement || measurement.unit === DishUnitMeasurementDto.Unit) {
    return null;
  }
  const grams = Math.round(measurement.quantity);
  return grams > 0 ? grams : null;
};

export const subgroupGramBudgetPerPerson = (rule: SubgroupUnitRule): number | null => {
  if (
    rule.perPersonUnit !== PerPersonUnitDto.Gram ||
    !hasPerPersonBudget(rule.maxPerPerson, rule.minPerPerson)
  ) {
    return null;
  }
  return perPersonUnits(rule.maxPerPerson, rule.minPerPerson);
};

export const isDishUnitMismatch = (
  measurement: DishMeasurementDto | null | undefined,
  rule: SubgroupUnitRule,
): boolean => subgroupGramBudgetPerPerson(rule) != null && gramsPerPortion(measurement) == null;
